import styled from 'styled-components';

const ServiceItemStyle = styled.div`
	--sizeIcon: var(--sp6x);
	--distanceIconText: var(--sp3x);
	--distanceCheckText: var(--sp2x);
	--distanceEveryText: var(--sp1x);
	--distanceTitleTag: var(--sp3x);

	transform: translate(var(--start-position));
	display: flex;
	flex-direction: row;

	.wrapper-icon-title {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	.icon {
		--iconSize: var(--sizeIcon);
		margin-right: var(--distanceIconText);

		color: var(--hoverPrimaryColor);
	}

	.tag-wrapper-outside {
		display: flex;
		flex-direction: column;
		margin-top: var(--distanceTitleTag);
		gap: var(--distanceEveryText);
	}

	.tag-wrapper {
		display: flex;
		align-items: center;
		gap: var(--distanceCheckText);

		p {
			line-height: 1;
		}

		.check-icon {
			--iconSize: calc(var(--sizeIcon) - var(--sp0-5x));
			color: var(--hoverPrimaryColor);
		}
	}

	&.translateMinus {
		--start-position: -100vw;
	}

	&.translatePlus {
		--start-position: 100vw;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeIcon: var(--sp4x);
		--distanceIconText: var(--sp2-5x);
		--distanceCheckText: var(--sp1-5x);
		--distanceEveryText: var(--sp1x);
		--distanceTitleTag: var(--sp2-5x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--sizeIcon: var(--sp3x);
		--distanceIconText: var(--sp2-5x);
		--distanceCheckText: var(--sp1x);
		--distanceEveryText: var(--sp1-5x);
		--distanceTitleTag: var(--sp2-5x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeIcon: var(--sp3x);
		--distanceIconText: var(--sp2-5x);

		--distanceEveryText: var(--sp1-5x);
		--distanceTitleTag: var(--sp2x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--sizeIcon: var(--sp3x);
		--distanceIconText: var(--sp1-5x);
		--distanceEveryText: var(--sp1-5x);
		--distanceTitleTag: var(--sp2x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceCheckText: var(--sp0-5x);
		--sizeIcon: var(--sp2-5x);
		--distanceIconText: var(--sp1-5x);

		--distanceEveryText: var(--sp1-5x);
		--distanceTitleTag: var(--sp1-5x);
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeIcon: var(--sp2-5x);
		--distanceIconText: var(--sp1x);

		--distanceEveryText: var(--sp1x);
		--distanceTitleTag: var(--sp1x);
	}
`;
export default ServiceItemStyle;
